var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 18", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M5.832 14.203a6.09 6.09 0 0 0 8.37-8.37l-8.37 8.37zm-2.035-2.035l8.371-8.37a6.09 6.09 0 0 0-8.37 8.37zM9 17.825A8.825 8.825 0 1 1 9 .175a8.825 8.825 0 0 1 0 17.65z", id: "a" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#a" })
      ),
      React.createElement("use", { fill: "#969EA2", xlinkHref: "#a" }),
      React.createElement(
        "g",
        { mask: "url(#b)", fill: "#959EA1" },
        React.createElement("path", { d: "M0 0h18v18H0z" })
      )
    )
  );
});